
export enum ProductFilterAllowedOptions {
    All,
    DisallowAnyProduct,
    DisallowProductTypeChange,
}